import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const riskPoints = [
  "9 out of 10 individual traders in equity Futures and Options Segment incurred net losses.",
  "On an average, loss makers registered net trading loss close to Rs. 50,000",
  "Over and above the net trading losses incurred, loss makers expended an additional 28% of net trading losses as transaction costs.",
  "Those making net trading profits, incurred between 15% to 50% of such profits as transaction cost.",
];

const riskLinks = [
  {
    title: "SEBI LINK OF RISK DISCLOSURE",
    url: "https://www.sebi.gov.in/sebi_data/commondocs/ann5risk_p.pdf",
  },
  {
    title:
      "STUDY - ANALYSIS OF PROFIT AND LOSS OF INDIVIDUAL TRADERS DEALING IN EQUITY F&O SEGMENT",
    url: "https://www.sebi.gov.in/reports-and-statistics/research/jan-2023/study-analysis-of-profit-and-loss-of-individual-traders-dealing-in-equity-fando-segment_67525.html",
  },
];

const RiskDisclosuresOfDerivatives = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Risk Disclosure for F&O Trading"
        description="Important SEBI risk disclosure for individual traders in equity Futures and Options (F&O) segment. Understand the risks and transaction costs associated with derivatives trading."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{ backgroundImage: "url('/images/other-banner.png')" }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Risk Disclosures of Derivatives</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              {riskPoints.map((point, index) => (
                <p key={index}>
                  {index + 1}. {point}
                </p>
              ))}
              {riskLinks.map((link, index) => (
                <p key={index}>
                  <a href={link.url} target="_blank" rel="noreferrer">
                    {link.title}
                  </a>
                </p>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default RiskDisclosuresOfDerivatives;
